import React from 'react';
import BDisplayBody from './BDisplayBody';

const BDisplaySurvey = (props) => {
  const { actionsBtn, survey_code } = props;
  return <BDisplayBody actionsBtn={actionsBtn} survey_code={survey_code} />;
};

export default BDisplaySurvey;
